// this is only used in the footer embed
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.appended = false;

    // callback is called on intersection change
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.9505152409088!2d-121.92592488403768!3d36.555306089144835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808de6154f24ed01%3A0xfc1acd6783833cbf!2sFourtan%C3%A9%20Jewelers!5e0!3m2!1sen!2sus!4v1613854761982!5m2!1sen!2sus';
    iframe.title = 'footer map';
    iframe.loading = 'lazy';

    const onIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.appended) {
          entry.target.append(iframe);
          this.appended = true;
        }
      });
    };

    // define an observer instance
    this.observer = new IntersectionObserver(onIntersection, {
      root: null,
      threshold: 0.1,
    });

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.unobserve(this.element);
  }

  beforeCache() {
    this.observer.unobserve(this.element);
  }
}

// %iframe{:src => 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3204.9505152409088!2d-121.92592488403768!3d36.555306089144835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808de6154f24ed01%3A0xfc1acd6783833cbf!2sFourtan%C3%A9%20Jewelers!5e0!3m2!1sen!2sus!4v1613854761982!5m2!1sen!2sus', :allowfullscreen => '', :loading => 'lazy', :title => 'footer map'}
